module.exports = __webpack_public_path__ + "static/img/RICHMOND.024083c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RICHMOND.svg
// module id = lIbZ
// module chunks = 0